import { render, staticRenderFns } from "./ScanBarcode.vue?vue&type=template&id=2d624519&"
import script from "./ScanBarcode.vue?vue&type=script&lang=js&"
export * from "./ScanBarcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports